import LoadingIndicator from 'gcs-common/components/LoadingIndicator/LoadingIndicator';

interface AdminTableTitleProps {
  title: string;
  numberOfItems?: number;
  isLoading: boolean;
}

const AdminTableTitle = (props: AdminTableTitleProps) => {
  const { title, numberOfItems, isLoading } = props;
  return (
    <div className="flex flex-row">
      <div className="py-2 pr-2 pl-0 text-[22px] text-grey-12">
        {title} ({numberOfItems ?? '-'})
      </div>
      {isLoading && <LoadingIndicator padding="0" />}
    </div>
  );
};

export default AdminTableTitle;
